<script>
/**
 * 通用 CTA 按钮（自 vancheen-b2b 的 CtaButton.vue 移植为 Vue 2 版本）
 * 原版基于 Element Plus el-button 的 tag 属性（Element UI 不支持），
 * 这里直接用 NhLink 渲染 router-link / <a>，视觉由 .btn 系列类还原。
 */
import NhLink from './NhLink.vue'
import NhSvgIcon from './NhSvgIcon.vue'

export default {
  name: 'NhCtaButton',
  components: { NhLink, NhSvgIcon },
  props: {
    label: { type: String, default: '' },
    /** 站内路由 */
    to: { type: [String, Object], default: '' },
    /** 站外链接 / mailto 等 */
    href: { type: String, default: '' },
    /** btn-primary | btn-outline | btn-light | btn-ghost-light */
    variant: { type: String, default: 'btn-primary' },
    large: { type: Boolean, default: true },
    external: { type: Boolean, default: false },
    icon: { type: String, default: '' }
  }
}
</script>

<template>
  <NhLink
    class="btn"
    :class="[variant, large ? 'btn-lg' : '']"
    :to="to"
    :href="href"
    :external="external"
  >
    <NhSvgIcon v-if="icon" :name="icon" />{{ label }}<slot />
  </NhLink>
</template>
